import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id E8557F02-8241-47FB-B546-402947A5818C
 * name drawing
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/drawing.svg
 * tags
 * - Drawing / Art 
 * - Shape 
 */
export const DrawingIcon = createSvgIcon(<><path d="M8.5,3A5.5,5.5 0 0,1 14,8.5C14,9.83 13.53,11.05 12.74,12H21V21H12V12.74C11.05,13.53 9.83,14 8.5,14A5.5,5.5 0 0,1 3,8.5A5.5,5.5 0 0,1 8.5,3Z" /></>, 'DrawingIcon');
export default DrawingIcon